import { render, staticRenderFns } from "./igt-settings.vue?vue&type=template&id=5a724c9b&scoped=true&"
import script from "./igt-settings.vue?vue&type=script&lang=js&"
export * from "./igt-settings.vue?vue&type=script&lang=js&"
import style0 from "./igt-settings.vue?vue&type=style&index=0&id=5a724c9b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a724c9b",
  null
  
)

export default component.exports